import { FunctionComponent, useEffect, useState } from "react";
import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";
import IntBarTable from "../IntBarTable/IntBarTable";
import DoughnutChartOrg from "../DoughnutChartOrg/DoughnutChartOrg";
import { colour_code } from "../../Values/constants";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import { DownloadReportCsv } from "../CommanDownloadFunction";
import { themeColors } from "../../Components/theme";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import "../../theme-vars.css";

type props = {
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  source: boolean;
  taskFilter: any;
  leadFilter: any;
  notInterestedReportData: any;
  theme: any;
};

const NotIntReason: FunctionComponent<props> = ({
  analyticsData,
  usersList,
  checked,
  history,
  teamsData,
  filter,
  source,
  taskFilter,
  leadFilter,
  notInterestedReportData,
  theme
}) => {

  /** ----------------------------------------------
*  Responsive Logic (MUI Breakpoints)
* ---------------------------------------------- */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  /** ----------------------------------------------
*  CSV Download Data State
* ---------------------------------------------- */
  const [notInterestedData, setNotInterestedReportData] = useState<any>([]);
  const [notInterestedHeader, setNotInterestedReportHeader] = useState<any>([]);

  /** ------------------------------------------------
* Extract headers from callback reason data
* ------------------------------------------------ */
  useEffect(() => {
    let headerArray: any[] = [];
    notInterestedReportData?.map((list: any) => {
      return list?.not_int_reason?.map((li: any) => {
        return headerArray.push(li.not_int_reason);
      })
    });
    setNotInterestedReportHeader(headerArray);
  }, [notInterestedReportData]);

  /** ------------------------------------------------
* Download CSV
* ------------------------------------------------ */
  const downLoadReport = () => {
    const csvReportData = DownloadReportCsv(notInterestedReportData, notInterestedHeader, usersList, 'not_int_reason');
    setNotInterestedReportData(csvReportData);
  }

  /** ------------------------------------------------
* Reusable styling for tables/cards by theme
* ------------------------------------------------ */
  const tableContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  /** CSS Variables */
  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeMedium = "var(--font-size-medium)";

  return (
    <>
      <Box
        className={`d-flex flex-column ${isMobile ? 'mb-2' : 'mb-3'}`}
        sx={{
          width: "100%",
          padding: isMobile ? 1 : 0,
        }}
      >

        {/* -------------------------------------------------------
       * Header Section with CSV Download Icon
       * ------------------------------------------------------- */}
        <h6 className={commonStyles.heading} style={{ fontFamily: fontFamilyMain, fontSize: fontSizeMedium, margin: isMobile ? "0px 0px 10px 5px" : "0px 0px 10px 0px" }}>
          Not Interseted Reason Summary
          <CSVLink onClick={downLoadReport} data={notInterestedData}>
            {" "}
            <svg
              style={{ cursor: "pointer", color: "rgb(39, 159, 159)" }}
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-download"
              viewBox="0 0 16 16"
            >
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
          </CSVLink>
        </h6>

        {/* -------------------------------------------------------
       * Content Area (Chart + Table)
       * ------------------------------------------------------- */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 4,
            width: "100%",
            alignItems: isMobile ? "stretch" : "flex-start",
          }}
        >
          <Box
            id="notIntReason"
            className="card p-4 shadow rounded"
            sx={{
              width: isMobile ? "100%" : "60%",
              maxHeight: 350,
              ...tableContainerStyles,
              mb: isMobile ? 2 : 0,
            }}
          >
            <IntBarTable
              data={analyticsData}
              type={"not_int_reason"}
              heading={"Not Interseted Reason Summary"}
              usersList={usersList}
              checked={checked}
              teamsData={teamsData}
              style={{ width: "100%" }}
              filter={filter}
              history={history}
              source={source}
              taskFilter={taskFilter}
              leadFilter={leadFilter}
            />
          </Box>

          {/* ----------------------
         * Table Box
         * ---------------------- */}
          <Box
            className="card p-4 shadow rounded"
            sx={{
              width: isMobile ? "100%" : "40%",
              minHeight: 350,
              maxHeight: 350,
              ...tableContainerStyles,
            }}
          >
            <Box
              id="notIntReason"
              sx={{
                width: "100%",
                ...tableContainerStyles,
                color: "#000"
              }}
            >
              <DoughnutChartOrg
                analyticsData={analyticsData}
                type={"not_int_reason"}
                color={colour_code}
                history={history}
                filter={filter}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

/**
 * Maps Redux state to component props.
 */
const mapStateToProps = (state: any) => {
  return {
    notInterestedReportData: state.notInterestedReportData.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(NotIntReason);
